import { ServiceDataFields } from './service-data-fields.enum';

export const venisafeFieldSet = [
  ServiceDataFields.Ethnicity,
  ServiceDataFields.PatientHistoryInformation,
  ServiceDataFields.CardiovascularConditions,
  ServiceDataFields.CardiovascularConditionsInFamilyHistory,
  ServiceDataFields.AdditionalPatientInformation,
  ServiceDataFields.Weight,
  ServiceDataFields.Height,
  ServiceDataFields.Ethnicity,
];
